export enum CountryAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_COUNTRY_LIST = "ADD_COUNTRY_LIST",
    UPDATE_COUNTRY_LIST = "UPDATE_COUNTRY_LIST",
    UPDATE_COUNTRY_SEARCH_REQ = "UPDATE_COUNTRY_SEARCH_REQ",
    SET_UPDATE_COUNTRY = "SET_UPDATE_COUNTRY"
}